import { HttpService } from "../../modules/shared/services/http.service";
import { Review, CreateReviewDto, UpdateReviewDto, QueryReviewDto, InfinityPaginationResponse, CreateVoteDto } from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

export const createReview = async (data: CreateReviewDto): Promise<Review> => {
	const response = await HttpService.post("api/v1/reviews", data, headers, true);
	return response;
};

export const updateReview = async (id: string, data: UpdateReviewDto): Promise<Review> => {
	const response = await HttpService.patch(`api/v1/reviews/${id}`, data, headers, true);
	return response;
};

export const getReviewById = async (id: string): Promise<Review> => {
	const response = await HttpService.get(`api/v1/reviews/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getReviews = async (query?: QueryReviewDto): Promise<InfinityPaginationResponse<Review>> => {
	const qs = new URLSearchParams();
	if (query) {
		Object.entries(query).forEach(([k, v]) => {
			if (v !== undefined && v !== null) {
				if (k === "filters" && typeof v === "object") {
					qs.append(k, JSON.stringify(v));
				} else if (k === "sort" && Array.isArray(v)) {
					qs.append(k, JSON.stringify(v));
				} else {
					qs.append(k, String(v));
				}
			}
		});
	}
	const response = await HttpService.get(`api/v1/reviews${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteReview = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/reviews/${id}`, { "x-custom-lang": "en" }, true);
};

export const getReviewsByUser = async (userId: string, query?: QueryReviewDto): Promise<InfinityPaginationResponse<Review>> => {
	const qs = new URLSearchParams();
	if (query) {
		Object.entries(query).forEach(([k, v]) => {
			if (v !== undefined && v !== null) {
				if (k === "filters" && typeof v === "object") {
					qs.append(k, JSON.stringify(v));
				} else if (k === "sort" && Array.isArray(v)) {
					qs.append(k, JSON.stringify(v));
				} else {
					qs.append(k, String(v));
				}
			}
		});
	}
	const response = await HttpService.get(`api/v1/reviews/user/${userId}${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getReviewsByAuthor = async (authorId: string, query?: QueryReviewDto): Promise<InfinityPaginationResponse<Review>> => {
	const qs = new URLSearchParams();
	if (query) {
		Object.entries(query).forEach(([k, v]) => {
			if (v !== undefined && v !== null) {
				if (k === "filters" && typeof v === "object") {
					qs.append(k, JSON.stringify(v));
				} else if (k === "sort" && Array.isArray(v)) {
					qs.append(k, JSON.stringify(v));
				} else {
					qs.append(k, String(v));
				}
			}
		});
	}
	const response = await HttpService.get(`api/v1/reviews/author/${authorId}${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const createVote = async (reviewId: string, data: CreateVoteDto): Promise<Review> => {
	const response = await HttpService.post(`api/v1/review-votes/review/${reviewId}/vote`, data, headers, true);
	return response;
};

export const removeVote = async (reviewId: string): Promise<Review> => {
	const response = await HttpService.deleteRecord(`api/v1/review-votes/review/${reviewId}/vote`, headers, true);
	return response;
};
